import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/atlassian/pipelines/agent/build/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["NBSP","BR"] */ "/opt/atlassian/pipelines/agent/build/src/blocks/components/I18nSubstitutions/index.tsx");
